<template>
<div id="info">
  <div class="info center">
    <h4 class="cyan-text text-darken-1">お知らせ</h4>
    <p>注意：本サービスは現在テスト版であり、頻繁にメンテナンスに入ります。</p>
<p>その際に、作成された「部屋」やそのやりとりのデータは削除する場合がございますので、ご了承ください。</p>

  </div>






</div>

</div>
</template>

<script>
export default {
  name: 'Info',
  data(){
    return{
      picked: null,
    }
  }
}

</script>

<style>





</style>



// WEBPACK FOOTER //
// src/components/info/Info.vue